"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPoolByCompany = void 0;
/**
 * Get jobs from the jobs pool for a given company code
 */
var getPoolByCompany = function (instance) {
    return function (companyCode, config) {
        return instance.get("/jobs/pool/".concat(companyCode), config);
    };
};
exports.getPoolByCompany = getPoolByCompany;
